import { render, staticRenderFns } from "./drugDetails.vue?vue&type=template&id=30374755&scoped=true&lang=html&"
import script from "./drugDetails.vue?vue&type=script&lang=js&"
export * from "./drugDetails.vue?vue&type=script&lang=js&"
import style0 from "./drugDetails.vue?vue&type=style&index=0&id=30374755&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30374755",
  null
  
)

export default component.exports